import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLogin }) => {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError('Por favor, complete todos los campos');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await onLogin(email, password);
    } catch (err) {
      setError(err.message || 'Error al iniciar sesión. Verifique sus credenciales');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="/admin/logo_cyker.png" alt="Cyker" className="login-logo-img" />
          <h1>Panel Administrativo</h1>
          <p>Ingrese sus credenciales para acceder</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="alert alert-error">{error}</div>}

          <div className="form-group">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email" id="email" className="form-control"
              value={email} onChange={e => setEmail(e.target.value)}
              placeholder="correo@ejemplo.com" disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">Contraseña</label>
            <input
              type="password" id="password" className="form-control"
              value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" disabled={loading}
            />
          </div>

          <button type="submit" className="btn btn-primary login-btn" disabled={loading}>
            {loading ? (<><span className="spinner-small"></span>Iniciando sesión...</>) : 'Iniciar Sesión'}
          </button>
        </form>

        <div className="login-footer">
          <p>Sistema de gestión de taxis Cyker</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
